type TimerDisplayProps = {
  elapsedSeconds: number;
  isRunning: boolean;
  onToggle: () => void;
  onReset: () => void;
};

function format(totalSeconds: number) {
  const safe = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  const seconds = safe % 60;
  return {
    hours: hours.toString().padStart(2, "0"),
    minutes: minutes.toString().padStart(2, "0"),
    seconds: seconds.toString().padStart(2, "0"),
  };
}

export default function TimerDisplay({
  elapsedSeconds,
  isRunning,
  onToggle,
  onReset,
}: TimerDisplayProps) {
  const t = format(elapsedSeconds);

  return (
    <div className="bg-white border border-gray-200 rounded-lg px-3 py-2 flex-shrink-0">
      <div className="flex items-center justify-between">
        <span className="text-xl font-semibold text-gray-800 font-mono tracking-wider tabular-nums">
          {t.hours}
          <span className="text-gray-300 mx-0.5">:</span>
          {t.minutes}
          <span className="text-gray-300 mx-0.5">:</span>
          {t.seconds}
        </span>
        <div className="flex items-center gap-1">
          <button
            onClick={onToggle}
            className="flex items-center justify-center w-8 h-8 rounded-md hover:bg-gray-100 text-gray-500 hover:text-gray-700 transition-colors cursor-pointer"
            aria-label={isRunning ? "일시정지" : "시작"}
          >
            <i
              className={`${isRunning ? "ri-pause-fill" : "ri-play-fill"} text-base`}
            ></i>
          </button>
          <button
            onClick={onReset}
            className="flex items-center justify-center w-8 h-8 rounded-md hover:bg-gray-100 text-gray-500 hover:text-gray-700 transition-colors cursor-pointer"
            aria-label="초기화"
          >
            <i className="ri-restart-line text-base"></i>
          </button>
        </div>
      </div>
    </div>
  );
}
